import { memo } from 'react';
import { withNamespaces } from 'react-i18next';

import { TasksStatuses } from 'src/modules/3rd-party-management/constants';

const TaskStatus = ({
    t,
    status
}) => {
    const config = TasksStatuses[status];

    if (!config) {
        return <span>—</span>;
    }

    return (
        <span
            className="overview-shared__risk-badge"
            style={{ backgroundColor: config.color }}
        >
            {t(config.title)}
        </span>
    );
};

export default withNamespaces()(memo(TaskStatus));
